import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./Registration.module.css";
import validator from "validator";

const Registration = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    password: "",
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { name, phone, email, password } = formData;
    
    if (!name || !phone || !email || !password) {
      setError("Заполните все поля");
      setSuccess("");
      return;
    }
    if (!validator.isAlpha(name.replace(/[\s\-]/g, ''), 'ru-RU')) {
        setError("Имя может содержать только русские буквы, пробелы и дефисы");
        setSuccess("");
        return;
      }
    const strictLatinEmailRegex = /^[a-zA-Z0-9@._%+-]+$/;
    if (!strictLatinEmailRegex.test(email)) {
        setError("Email должен содержать только латинские буквы, цифры и символы @ . _ % + -");
        setSuccess("");
        return;
    }
    if (!validator.isEmail(email)) {
      setError("Введите корректный email адрес");
      setSuccess("");
      return;
    }
    const phoneRegex = /^\+\d{1,3}\(\d{3}\)\d{3}-\d{2}-\d{2}$/;
    if (!phoneRegex.test(phone)) {
      setError("Телефон должен быть в формате: +7(000)000-00-00");
      setSuccess("");
      return;
    }

    setError("");

    try {

      const response = await fetch("/api/sign-up/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
      
      if (response.ok) {
        setSuccess("Форма успешно отправлена!");
        setFormData({ name: "", phone: "", email: "", password: "" });
      } else {
        const errorData = await response.json();
        
        if (errorData.errors) {
          const errorMessages = Object.values(errorData.errors).join(", ");
          setError(`Произошла ошибка: ${errorMessages}`);
        } else if (errorData.error) {
          setError(`Произошла ошибка: ${errorData.error}`);
        } else {
          setError("Произошла ошибка при отправке формы");
        }
      }
    } catch (err) {
      setError("Ошибка сети. Попробуйте позже.");
    }
  };

  const handleLoginClick = () => {
    navigate("/login");
  };

  return (
    <div className={styles.registrationContainer}>
      <div className={styles.registrationForm}>
        <h2 className={styles.title}>Регистрация</h2>
        <form className={styles.form} onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Имя"
            value={formData.name}
            onChange={handleChange}
            className={styles.input}
          />
          <input
            type="tel"
            name="phone"
            placeholder="Телефон"
            value={formData.phone}
            onChange={handleChange}
            className={styles.input}
          />
          <input
            name="email"
            placeholder="Электронная почта"
            value={formData.email}
            onChange={handleChange}
            className={styles.input}
          />
          <input
            type="password"
            name="password"
            placeholder="Пароль"
            value={formData.password}
            onChange={handleChange}
            className={styles.input}
          />
          <button type="submit" className={styles.button}>
            Зарегистрироваться
          </button>
        </form>
        
        <div className={styles.loginLink}>
          <span>Уже есть аккаунт? </span>
          <button onClick={handleLoginClick} className={styles.loginButton}>
            Войти
          </button>
        </div>

        {error && <p className={styles.error}>{error}</p>}
        {success && <p className={styles.success}>{success}</p>}
      </div>
    </div>
  );
};

export default Registration;